const INPUTS_QUE_NAO_SAO_TEXTO = ["checkbox", "radio", "button", "submit", "reset", "file", "hidden", "range", "color"];

interface TeclaNoFiltro {
  key: string;
  target: EventTarget;
  defaultPrevented: boolean;
}

export const enterDisparaFiltro = ({ key, target, defaultPrevented }: TeclaNoFiltro) =>
  key === "Enter" &&
  !defaultPrevented &&
  target instanceof HTMLInputElement &&
  !INPUTS_QUE_NAO_SAO_TEXTO.includes(target.type);
